import thunk from 'redux-thunk';
import { createStore, applyMiddleware } from 'redux';
import { logger } from 'redux-logger';
import rootReducer from './reducer/index';

const middlewares = [thunk];

export const store = createStore(rootReducer, applyMiddleware(...middlewares));
